import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { TdActions } from '@/components/tdActions'
import Icon from '@/components/Icon'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { ReportingGroupMemberType } from '@/enums/ReportingGroupMemberType'
import { SubmitterType } from '@/enums/SubmitterType'

export function submitterActionsCell (props) {
  class SubmitterActionsCell extends GridCell {
    dialogProps (dataItem) {
      if (dataItem.type === ReportingGroupMemberType.EXCLUDE) {
        return {
          title: 'Reporting.ReincludeInstitutionTitle',
          content: 'Reporting.ReincludeInstitutionContent'
        }
      }
      if (dataItem.submitterType === SubmitterType.INSTITUTION) {
        return {
          title: 'Reporting.RemoveInstitutionTitle',
          content: 'Reporting.RemoveInstitutionContent'
        }
      }
      return {
        title: 'Reporting.ExcludeInstitutionTitle',
        content: 'Reporting.ExcludeInstitutionContent'
      }
    }
    render () {
      const { dataItem } = this.props
      const confirmDialogProperties = this.dialogProps(dataItem)
      const iconName = (dataItem.type === ReportingGroupMemberType.EXCLUDE ? 'plus' : 'x')
      return (
        <TdActions>
          <button
            disabled={props.disabled}
            className='btn-icon'
            title={props.localize(confirmDialogProperties.title)}
            onClick={() => getStore().dispatch(dialogActions.openDialog({
              dialogType: dialogTypes.confirm,
              ...confirmDialogProperties,
              onAction: () => props.onClick(dataItem)
            }))}>
            <Icon name={iconName} />
          </button>
        </TdActions>
      )
    }
  }

  return {
    field: 'id',
    title: props.title || ' ',
    sortable: false,
    filterable: false,
    width: 45,
    cell: SubmitterActionsCell
  }
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingGroups/reportingGroupDetail.ActionButtonsCell.js